import { Link as SpectrumLink } from '@adobe/react-spectrum';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { usePublisherLink } from '@exchange-frontends/custom-hooks';

import { useStore } from '../../../store';
import { AppDetailsContext } from '../AppDetails';

/** @param {React.PropsWithChildren & import('@adobe/react-spectrum').SpectrumLinkProps} props */
const PublisherLink = ({ children, ...spectrumLinkProps }) => {
  const detailScreen = useStore((state) => state.detailScreen || {});
  const { cloud } = useContext(AppDetailsContext);
  const { publisher, appType } = detailScreen;
  const { publisherLink, publisherTarget } = usePublisherLink({ publisher, appType, cloud });

  return (
    <SpectrumLink isQuiet variant="secondary" {...spectrumLinkProps}>
      <StyledRouterLink to={publisherLink} target={publisherTarget} rel="noopener noreferrer">
        {children}
      </StyledRouterLink>
    </SpectrumLink>
  );
};

const StyledRouterLink = styled(Link)`
  font-size: 14px;
`;

export default PublisherLink;
